interface ResolveResourceScheduleCurrentTimePositionOptions {
  isToday: boolean;
  now?: Date;
  timelineStart: Date;
  intervalMinutes: number;
  slotWidth: number;
}

export function resolveResourceScheduleCurrentTimePosition({
  isToday,
  now = new Date(),
  timelineStart,
  intervalMinutes,
  slotWidth,
}: ResolveResourceScheduleCurrentTimePositionOptions): number | null {
  if (!isToday) {
    return null;
  }

  const minutesSinceTimelineStart = (now.getTime() - timelineStart.getTime()) / 1000 / 60;

  if (minutesSinceTimelineStart < 0) {
    return null;
  }

  return (minutesSinceTimelineStart / intervalMinutes) * slotWidth;
}